import Link from 'next/link'
import React from 'react'

function StillHere() {
   return (
      <section className="info_tell still">
         <div className="container container-xxl">
            <div className="justify-content-center">
               <div className="still-here align-items-center">
                  <div className="still-here-video-play">
                     <h2 className="section_heading_title mb-sm-3 m-0 text-md-start text-center">
                        Still here?
                     </h2>
                     <p className="info_tell_description text-md-start text-center">
                        Then you’re probably our kind of client. Let’s ditch the
                        boring and build something epic together.
                     </p>
                  </div>
                  <Link
                     href="/discover-benzatine/contact-us"
                     className="btn-primary info_tell_btn still-here-btn  "
                  >
                     <span>
                        let’s talk <br /> to benzatine
                     </span>
                     <svg
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                     >
                        <g clipPath="url(#clip0_4080_17978)">
                           <path
                              d="M41.7224 20.3271L32.1772 10.7818C31.8343 10.3814 31.2317 10.3347 30.8313 10.6777C30.4309 11.0206 30.3842 11.6232 30.7272 12.0236C30.7593 12.061 30.794 12.0957 30.8313 12.1277L38.7443 20.0503H0.954499C0.427375 20.0503 0 20.4776 0 21.0048C0 21.532 0.427375 21.9593 0.954499 21.9593H38.7443L30.8313 29.8723C30.4309 30.2152 30.3842 30.8178 30.7272 31.2182C31.0702 31.6186 31.6727 31.6653 32.0731 31.3223C32.1105 31.2903 32.1452 31.2556 32.1772 31.2182L41.7225 21.6729C42.0925 21.3007 42.0925 20.6994 41.7224 20.3271Z"
                              fill="#1F473E"
                           />
                        </g>
                        <defs>
                           <clipPath id="clip0_4080_17978">
                              <rect width="42" height="42" fill="white" />
                           </clipPath>
                        </defs>
                     </svg>
                  </Link>
               </div>
            </div>
         </div>
      </section>
   )
}

export default StillHere
